import { captureException } from '@sentry/browser';
import { AxiosResponse } from 'axios';
import { Installments } from 'src/components/OrderSummary/types';

import { Environment } from 'src/utils/Environment';

type TaxRateResponse = {
  taxRate: number;
};

type OrderItem = {
  fdmpId: string;
  digitalCatalogId: string;
  purchaseType: Installments;
  quantity: number;
};

type Order = {
  planId: string;
  bundleId?: string;
  promoCode?: string;
  shippingAddress: {
    city: string;
    lineOne: string;
    lineTwo?: string;
    state: string;
    zipCode: string;
  };
  items: OrderItem[];
};

export type GrowthLeadRequest = {
  email: string;
  firstName: string;
  lastName: string;
  businessName: string;
  marketingInfo: { [key: string]: any };
  chainAgentId: string;
  activityType: string;
  resellerUuid: string;
  salesforceOwnerId: string;
  orderTemplateCode?: string;
  order?: Order;
};

export type GrowthLeadResponse = GrowthLeadRequest & {
  uuid: string;
};

export const getTaxRate = async ({
  resellerId,
  address,
}: {
  resellerId: string;
  address: {
    city: string;
    zip: string;
  };
}): Promise<number> => {
  try {
    const response = await Environment.current.growthApiClient.post<TaxRateResponse>(
      `v3/shop/resellers/${resellerId}/tax_rate`,
      address
    );
    return response.data.taxRate / Math.pow(10, 5);
  } catch (error) {
    captureException(error);
    throw error;
  }
};

export const generateLead = async (payload: GrowthLeadRequest) => {
  return Environment.current.growthApiClient.put<GrowthLeadRequest, AxiosResponse<GrowthLeadResponse>>(
    '/growth/shop/v2/leads',
    payload
  );
};

export const generateEmail = async (leadId: string) => {
  const payload = { id: leadId };
  return Environment.current.growthApiClient.post(
    '/v3/cart_accounts',
    payload
  );
};
